import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import CustomerTable from './Table';
import CustomerView from './View';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: CustomerTable, exact: true },
  { path: 'new', component: CustomerView, exact: true },
  { path: ':id', component: CustomerView, exact: true },
];
/* eslint-enable prettier/prettier */

class Customer extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN])(Customer);
